module.exports = __webpack_public_path__ + "img/2-4.76d83100.jpg";